export const common = {
  // Header
  "header.solutions": "解决方案",
  "header.about": "关于我们", 
  "header.testimonials": "客户评价",
  "header.contact": "联系我们",
  "header.getStarted": "开始使用",
  
  // Hero Section
  "hero.slide1.title": "用智能AI优化运营流程",
  "hero.slide1.subtitle": "通过前沿AI代理优化您的工业流程，提升美国各地的效率和生产力。",
  "hero.slide2.title": "AI驱动的工业卓越", 
  "hero.slide2.subtitle": "通过智能自动化和预测分析转型您的制造流程。",
  "hero.slide3.title": "智能数字解决方案",
  "hero.slide3.subtitle": "利用代理AI的力量为先进自动化系统和智能工业运营提供支持。",
  "hero.optimizeWithAI": "AI优化",
  "hero.learnMore": "了解更多",
  
  // About Section
  "about.title": "通过AI创新赋能各行各业",
  "about.paragraph1": "在AiCH，我们站在通过先进AI代理转型工业格局的前沿。我们总部位于美国，使命是提升各个领域的运营效率和创新。",
  "about.paragraph2": "我们的前沿解决方案与现有系统无缝集成，推动增长和可持续发展。加入我们，以智慧和创造力塑造工业的未来。",
  
  // Values Section
  "values.badge": "提升行业",
  "values.title": "为工业增长创新AI",
  "values.subtitle": "通过前沿AI解决方案赋能各行各业，推动进步，提高效率，并在美国各地促进可持续增长。",
  "values.innovation.title": "创新",
  "values.innovation.description": "在AiCH，我们致力于突破技术边界。我们的团队不断探索AI的新前沿，提供能够赋能各行各业的前沿解决方案。",
  "values.integrity.title": "诚信",
  "values.integrity.description": "我们相信以最高水平的诚实和透明度进行业务。我们的客户信任我们提供可靠和符合道德标准的AI解决方案，推动成功。",
  "values.collaboration.title": "协作",
  "values.collaboration.description": "团队合作是我们所做一切的核心。我们培养一个多元化想法蓬勃发展的协作环境，产生创造性解决方案和共同成功。",
  "values.excellence.title": "卓越",
  "values.excellence.description": "我们对卓越的追求驱动我们提供优质的产品和服务。我们致力于在所做的一切中达到最高标准，确保为客户提供质量和价值。",
  "values.sustainability.title": "可持续性",
  "values.sustainability.description": "AiCH致力于既有利于客户又有利于地球的可持续实践。我们努力创造不仅有效而且对环境负责的AI解决方案。",
  
  // Solutions Section
  "solutions.badge": "效率释放",
  "solutions.title": "使用先进AI优化效率",
  "solutions.subtitle": "通过为工业应用量身定制的前沿AI解决方案提升生产力，推动前所未有的增长和卓越运营。",
  "solutions.predictiveMaintenance.title": "预测性维护",
  "solutions.predictiveMaintenance.description": "利用AI预测设备故障并减少停机时间。",
  "solutions.processOptimization.title": "流程优化",
  "solutions.processOptimization.description": "通过AI驱动的洞察提升运营效率。",
  "solutions.qualityControl.title": "质量控制自动化", 
  "solutions.qualityControl.description": "实施AI确保一致的产品质量并减少缺陷。",
  "solutions.supplyChain.title": "供应链效率",
  "solutions.supplyChain.description": "通过AI分析优化物流和库存管理。",
  "solutions.energyManagement.title": "能源管理",
  "solutions.energyManagement.description": "使用AI监控和调整使用量以减少能源消耗。",
  "solutions.safetyMonitoring.title": "安全监控",
  "solutions.safetyMonitoring.description": "通过AI驱动的监控和警报提升工作场所安全。",
  
  // Testimonials Section
  "testimonials.badge": "验证影响",
  "testimonials.title": "听听我们合作伙伴的声音", 
  "testimonials.subtitle": "AiCH的创新AI解决方案改变了我们的运营，提升了效率并推动了前所未有的增长。强烈推荐！",
  "testimonials.jordan.content": "AiCH通过其前沿AI解决方案彻底改变了我们的运营。效率和生产力飞速提升，让我们能够专注于战略增长。",
  "testimonials.alex.content": "AiCH的AI代理改变了我们的工作流程效率和创新。他们在工业AI方面的专业知识无与伦比，为我们提供了战略洞察和可持续增长。",
  "testimonials.taylor.content": "与AiCH合作对我们来说是变革性的。他们的AI驱动解决方案优化了我们的流程，提升了效率和创新。这是任何行业的游戏规则改变者。",
  
  // CTA Section
  "cta.title": "今天就转型您的行业",
  "cta.subtitle": "通过为工业领导者量身定制的AiCH先进AI解决方案，释放前所未有的效率和创新。提升您的运营，在竞争激烈的市场中保持领先。",
  "cta.exploreSolutions": "探索解决方案",
  "cta.scheduleDemo": "预约演示",
  
  // Language Switcher
  "language.select": "语言"
};

export default {
  ...common,
  cta: {
    title: '准备好转型您的行业了吗？',
    subtitle: '加入利用AI推动创新和效率的领先企业。让我们讨论我们的解决方案如何使您的业务受益。',
    exploreSolutions: '探索解决方案',
    scheduleDemo: '预约演示'
  },
  demo: {
    title: '预约演示',
    subtitle: '填写下面的表单，我们的团队将很快与您联系，安排个性化演示。',
    name: '姓名',
    namePlaceholder: '请输入您的姓名',
    email: '电子邮箱',
    emailPlaceholder: '请输入您的邮箱',
    company: '公司名称',
    companyPlaceholder: '请输入您的公司名称',
    phone: '联系电话',
    phonePlaceholder: '请输入您的电话号码',
    message: '补充信息',
    messagePlaceholder: '告诉我们您的需求和兴趣...',
    submit: '提交申请',
    submitting: '提交中...',
    cancel: '取消',
    successMessage: '感谢您！您的演示申请已成功提交。我们将尽快与您联系。',
    errorMessage: '抱歉，提交申请时出现错误。请重试。'
  }
};
